var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative",staticStyle:{"height":"35px"}},[_c('input',{ref:"input",staticClass:"form-control clip-input",attrs:{"type":"number","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.limitInput}}),_vm._v(" "),_c('label',{staticClass:"text-muted"},[_vm._v("%")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0312e28b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PercentInput.vue
// module id = null
// module chunks = 